"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FLDFAQInitialValues = exports.ProductCategoryInitialValues = exports.EditProductInitialValues = exports.AddProductInitialValues = exports.SecondaryBannerInitialValues = exports.HomepageBannerInitialValues = exports.PromoCodeInitialValues = void 0;
const Utils_1 = require("../Utils");
exports.PromoCodeInitialValues = {
    title: '',
    description: '',
    code: '',
    quantity: 1,
    isFreeShippingPromo: false,
    isPercentage: false,
    discountPercentage: 0,
    discountPrice: '0.00',
    isPromoBanner: false,
};
exports.HomepageBannerInitialValues = {
    title: '',
    description: '',
    hasProductButton: false,
    productId: '',
};
exports.SecondaryBannerInitialValues = { title: '' };
exports.AddProductInitialValues = {
    name: '',
    description: '',
    longDescription: '',
    category: [],
    brand: '',
    isDiscount: false,
    discount: '0.00',
    sku: '',
    metaTitle: '',
    metaKeywords: '',
    metaDescription: '',
    variations: [{ name: '', variationData: [{ value: '', unitPrice: '', unitWeight: '', unitsInStock: '' }] }],
};
const EditProductInitialValues = (product) => {
    return Object.assign(Object.assign({}, product), { variations: product.variations
            ? transformProductVariation(product.variations)
            : [{ name: '', variationData: [{ value: '', unitPrice: '', unitWeight: '', unitsInStock: '' }] }] });
};
exports.EditProductInitialValues = EditProductInitialValues;
const transformProductVariation = (variations) => {
    let finalVariations = [];
    variations.forEach((variation) => {
        let variationDataArr = [];
        variation.variationData.forEach((data) => {
            variationDataArr.push({
                id: data.id,
                value: data.value,
                unitPrice: Number(Utils_1.convertCentsToPrice(data.unitPrice)),
                unitWeight: data.unitWeight,
                unitsInStock: data.unitsInStock,
            });
        });
        finalVariations.push({
            id: variation.id,
            name: variation.name,
            variationData: variationDataArr,
        });
    });
    return finalVariations;
};
exports.ProductCategoryInitialValues = { name: '' };
exports.FLDFAQInitialValues = { category: 'General', question: '', answer: '' };
//# sourceMappingURL=AdminFLD.js.map